import CreditLine from './views/credit-line.c';
export default CreditLine;
